(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid-item"] && !Shopify.designMode) return;
  try {
    (() => {
    const elementName = 'libas-product-card-campaign-badge';

    if (
      !('customElements' in window) ||
      typeof Intl === 'undefined' ||
      typeof Intl.DateTimeFormat !== 'function' ||
      customElements.get(elementName)
    ) {
      return;
    }

    const timeZone = 'Asia/Kolkata';
    const istOffsetMilliseconds = 330 * 60 * 1000;
    const days = [
      'sunday',
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
    ];
    const weekdayIndexes = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6,
    };

    let formatter;

    try {
      formatter = new Intl.DateTimeFormat('en-GB-u-hc-h23', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
      });
    } catch (error) {
      return;
    }

    const getIstParts = (date) => {
      const values = {};

      formatter.formatToParts(date).forEach((part) => {
        if (part.type !== 'literal') {
          values[part.type] = part.value;
        }
      });

      const weekdayIndex = weekdayIndexes[values.weekday];

      if (weekdayIndex === undefined) {
        return null;
      }

      return {
        year: Number(values.year),
        month: Number(values.month),
        day: Number(values.day),
        weekdayIndex,
        minuteOfDay: Number(values.hour) * 60 + Number(values.minute),
      };
    };

    const parseTime = (value) => {
      const match = /^(?:[01]\d|2[0-3]):[0-5]\d$/.exec(value || '');

      if (!match) {
        return null;
      }

      const [hour, minute] = value.split(':').map(Number);
      return hour * 60 + minute;
    };

    const parseIstDateTime = (dateValue, timeValue) => {
      const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateValue || '');
      const minuteOfDay = parseTime(timeValue);

      if (!dateMatch || minuteOfDay === null) {
        return null;
      }

      const year = Number(dateMatch[1]);
      const month = Number(dateMatch[2]);
      const day = Number(dateMatch[3]);

      if (year < 2000 || year > 2999) {
        return null;
      }

      const hour = Math.floor(minuteOfDay / 60);
      const minute = minuteOfDay % 60;
      const timestamp = Date.UTC(year, month - 1, day, hour, minute) - istOffsetMilliseconds;
      const verified = getIstParts(new Date(timestamp));

      if (
        !verified ||
        verified.year !== year ||
        verified.month !== month ||
        verified.day !== day ||
        verified.minuteOfDay !== minuteOfDay
      ) {
        return null;
      }

      return timestamp;
    };

    const isWithinWindow = (minuteOfDay, start, end) => {
      if (start === null || end === null || start === end) {
        return false;
      }

      if (start < end) {
        return minuteOfDay >= start && minuteOfDay < end;
      }

      return minuteOfDay >= start || minuteOfDay < end;
    };

    const getWeeklyWindow = (element, day) => {
      if (element.dataset[`${day}Enabled`] !== 'true') {
        return null;
      }

      const start = parseTime(element.dataset[`${day}StartTime`]);
      const end = parseTime(element.dataset[`${day}EndTime`]);

      if (start === null || end === null || start === end) {
        return null;
      }

      return { start, end };
    };

    const isActive = (element, now) => {
      const mode = element.dataset.scheduleMode;

      if (mode === 'once') {
        const start = parseIstDateTime(
          element.dataset.onceStartDate,
          element.dataset.onceStartTime,
        );
        const end = parseIstDateTime(
          element.dataset.onceEndDate,
          element.dataset.onceEndTime,
        );

        return start !== null && end !== null && end > start && now.getTime() >= start && now.getTime() < end;
      }

      const current = getIstParts(now);

      if (!current) {
        return false;
      }

      if (mode === 'daily') {
        return isWithinWindow(
          current.minuteOfDay,
          parseTime(element.dataset.dailyStartTime),
          parseTime(element.dataset.dailyEndTime),
        );
      }

      if (mode !== 'weekly') {
        return false;
      }

      const currentWindow = getWeeklyWindow(element, days[current.weekdayIndex]);

      if (currentWindow) {
        if (
          currentWindow.start < currentWindow.end &&
          current.minuteOfDay >= currentWindow.start &&
          current.minuteOfDay < currentWindow.end
        ) {
          return true;
        }

        if (currentWindow.start > currentWindow.end && current.minuteOfDay >= currentWindow.start) {
          return true;
        }
      }

      const previousDayIndex = (current.weekdayIndex + 6) % 7;
      const previousWindow = getWeeklyWindow(element, days[previousDayIndex]);

      return Boolean(
        previousWindow &&
          previousWindow.start > previousWindow.end &&
          current.minuteOfDay < previousWindow.end,
      );
    };

    const elements = new Set();
    let timerId = null;

    const scheduleNextUpdate = () => {
      if (!elements.size) {
        timerId = null;
        return;
      }

      const delay = 60000 - (Date.now() % 60000) + 50;
      timerId = window.setTimeout(updateAll, delay);
    };

    const updateAll = () => {
      if (timerId !== null) {
        window.clearTimeout(timerId);
      }

      timerId = null;
      const now = new Date();

      elements.forEach((element) => element.updateSchedule(now));
      scheduleNextUpdate();
    };

    const scheduler = {
      add(element) {
        elements.add(element);
        element.updateSchedule(new Date());

        if (timerId === null) {
          scheduleNextUpdate();
        }
      },
      remove(element) {
        elements.delete(element);

        if (!elements.size && timerId !== null) {
          window.clearTimeout(timerId);
          timerId = null;
        }
      },
      refresh: updateAll,
    };

    class ProductCardCampaignBadge extends HTMLElement {
      connectedCallback() {
        scheduler.add(this);
      }

      disconnectedCallback() {
        scheduler.remove(this);
      }

      updateSchedule(now) {
        let active = false;

        try {
          active = isActive(this, now);
        } catch (error) {
          active = false;
        }

        this.toggleAttribute('hidden', !active);
        this.setAttribute('aria-hidden', active ? 'false' : 'true');
      }
    }

    customElements.define(elementName, ProductCardCampaignBadge);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        scheduler.refresh();
      }
    });

    window.addEventListener('pageshow', scheduler.refresh);
  })();
  } catch(e) { console.error(e); }
})();

})();
